<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-multiple-template-root -->
<template>
  <div
      class="row"
      v-for="(question, i) in page.questions"
      v-bind:key="question"
      :class="i > 0 ? 'mt-70' : 'mt-0'"
  >
    <div class="col-xl-12">
      <StepNumbers
          class="step-number-lg"
          :steps="pageCount"
          v-if="i === 0"
          :current="step"
          v-on:changePage="changePage"
      ></StepNumbers>
    </div>
    <div class="col-lg-5">
      <StepNumbers
          :steps="pageCount "
          v-if="i === 0"
          :current="step"
          v-on:changePage="changePage"
          class="step-number-sm"
      ></StepNumbers>
      <div class="questions-section">
        <h3 class="headline headline-5" :class="i > 0 ? 'mt-0' : ''">
          {{ question.header }}
        </h3>
        <div v-html="question.text"></div>
      </div>
    </div>
    <div class="col-lg-7 answers-container">
      <div class="text-danger" v-if="isError(this.selectedAnswers[i])">
        <span>{{ errorMessage }}</span>
      </div>
      <div
          class="row row-answers"
          v-if="isProduct(question.type)"
      >
        <div
            class="text-center"
            v-for="product in this.availableProducts"
            v-bind:key="product"
        >
          <a :href="product.link" v-if="product.link">
            <div class="img-layer">
              <img
                  v-if="product.image !== ''"
                  :src="product.image"
                  :alt="product.subheader"
              />
              <div v-if="product.header" class="img-header">
                <span>{{ product.header }}</span>
              </div>
              <div v-if="product.subheader" class="img-subheader">
                <span>{{ product.subheader }}</span>
              </div>
            </div>
          </a>
          <div class="img-layer" v-else>
            <img
                v-if="product.image !== ''"
                :src="product.image"
                :alt="product.subheader"
            />
            <div v-if="product.header" class="img-header">
              <span>{{ product.header }}</span>
            </div>
            <div v-if="product.subheader" class="img-subheader">
              <span>{{ product.subheader }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-answers" v-else>
        <div
            class="text-center"
            v-for="answer in question.answers"
            v-bind:key="answer"
        >
          <div
              class="img-layer"
              @click="(e) => selectAnswer(i, answer)"
              :class="isAnswerSelected(i, answer) ? 'selected' : ''"
          >
            <img :src="answer.image" :alt="answer.subheader" />
            <div v-if="answer.header" class="img-header">
              <span>{{ answer.header }}</span>
            </div>
            <div v-if="answer.subheader" class="img-subheader">
              <span>{{ answer.subheader }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-7 offset-lg-5">
      <div
          class="mt-70 d-flex justify-content-between"
          v-if="i === page.questions.length - 1"
      >
        <button
            class="button button-outline"
            v-show="step !== 1"
            @click="backPage"
        >
          BACK
        </button>
        <button
            class="next-btn button button-outline"
            @click="nextPage"
            v-if="pageCount !== this.step"
        >
          NEXT
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import StepNumbers from "@/components/StepNumbers";
const CHECK_TYPE = "check";
const PRODUCTS_TYPE = "products";
export default {
  name: "QuestionsComponent",
  components: {
    StepNumbers,
  },
  data() {
    return {
      selectedAnswers: [],
      errorMessage: "",
    };
  },
  created() {
    this.page.questions.forEach((question) => {
      if (question.type !== PRODUCTS_TYPE) {
        if (question.type === CHECK_TYPE) this.selectedAnswers.push([]);
        else this.selectedAnswers.push({});
      }
    });
  },
  methods: {
    isError(selectedAnswer) {
      if (Array.isArray(selectedAnswer))
        return this.errorMessage !== "" && selectedAnswer.length === 0;
      else return this.errorMessage !== "" && !selectedAnswer;
    },
    selectAnswer(i, answer) {
      const questionType = this.page.questions[i].type;
      answer.questionLabel = this.page.questions[i].header;
      if (questionType === CHECK_TYPE) {
        this.selectCheckAnswer(i, answer);
      } else {
        this.selectRadioAnswer(i, answer);
      }
      this.sendValidationStatus();
      this.$emit("answers", this.selectedAnswers);
      this.$emit("updateProducts");
    },
    isAnswerNull(selectedAnswer) {
      if (Array.isArray(selectedAnswer)) return selectedAnswer.length === 0;
      else return !selectedAnswer.value;
    },
    sendValidationStatus() {
      let status = true;
      for (let i = 0; i < this.selectedAnswers.length; i++) {
        status = !this.isAnswerNull(this.selectedAnswers[i]);
        if (status === false) break;
      }
      this.$emit("validationstatus", { page: this.step, status: status });
    },
    isAnswerSelected(i, answer) {
      const questionType = this.page.questions[i].type;
      if (questionType === CHECK_TYPE)
        return this.answerExists(answer, this.selectedAnswers[i]);
      else return this.selectedAnswers[i] === answer;
    },
    answerExists(answer, answers) {
      let answerExists = false;
      answers.forEach((_answer) => {
        if (_answer === answer) answerExists = true;
      });
      return answerExists;
    },
    removeAnswerFromArray(answer, answers) {
      let finalAnswers = [];
      answers.forEach((_answer) => {
        if (_answer !== answer) finalAnswers.push(_answer);
      });
      return finalAnswers;
    },
    selectCheckAnswer(i, answer) {
      if (!this.answerExists(answer, this.selectedAnswers[i])) {
        this.selectedAnswers[i].push(answer);
      } else {
        this.selectedAnswers[i] = this.removeAnswerFromArray(
            answer,
            this.selectedAnswers[i]
        );
      }
    },
    selectRadioAnswer(i, answer) {
      if (answer === this.selectedAnswers[i]) this.selectedAnswers[i] = {};
      else {
        this.selectedAnswers[i] = answer;
      }
    },
    isQuestionsAnswered() {
      let isAnswered = true;
      for (let i = 0; i < this.selectedAnswers.length; i++) {
        if (
            (!Array.isArray(this.selectedAnswers[i]) &&
                !this.selectedAnswers[i].value) ||
            (Array.isArray(this.selectedAnswers[i]) &&
                this.selectedAnswers[i].length === 0)
        )
          return false;
      }
      return isAnswered;
    },
    isProduct(type) {
      return PRODUCTS_TYPE === type;
    },
    changePage(page) {
      this.errorMessage = "";
      if (page < this.step || this.isQuestionsAnswered()) {
        this.$emit("changePage", page);
      }
      else this.errorMessage = "Please answer the question";
    },
    backPage() {
      this.changePage(this.step - 1);
    },
    nextPage() {
      this.changePage(this.step + 1);
    },
  },
  props: ["pageCount", "page", "availableProducts", "step"],
};
</script>

<style scoped>
@media (max-width: 1199px) {
  #configurator-app .answers-container .row > * {
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>
